import React from 'react';
import { Link } from 'react-router-dom';

import KidsImage from '../../assets/academy_images/Kids.jpg';
import TeensImage from '../../assets/academy_images/Teens.jpg';
import PrivateGroupImage from '../../assets/academy_images/PrivateGroup.jpg';
import CorporateImage from '../../assets/academy_images/Corporate.jpg';
import GovernmentImage from '../../assets/academy_images/Government.jpg';
function Academy() {
  const categories = [
    {
      id: 'kids',
      title: 'Kids',
      description: 'Fun and engaging financial literacy programs designed specifically for children to learn money management through play.',
      image: KidsImage,
      link: '/academy/kids',
      color: 'from-[#FED700] to-[#F4900C]',
    },
    {
      id: 'teens-adults',
      title: 'Teens & Adults',
      description: 'Advanced financial education courses covering investment, budgeting, and wealth building for teenagers and adults.',
      image: TeensImage,
      link: '/academy/teens-adults',
      color: 'from-[#F4900C] to-[#FED700]',
    },
    {
      id: 'private-group',
      title: 'Private Group',
      description: 'Customized financial literacy programs for private groups.',
      image: PrivateGroupImage,
      link: '/academy/private-group',
      color: 'from-[#FED700] to-[#F4900C]',
    },
    {
      id: 'corporate',
      title: 'Corporate',
      description: 'Professional financial wellness programs designed for organizations to empower employees with financial knowledge.',
      image: CorporateImage,
      link: '/academy/corporate',
      color: 'from-[#F4900C] to-[#FED700]',
    },
    {
      id: 'government',
      title: 'Government & Public Sector',
      description: 'Financial literacy and money management programs tailored for government agencies, public institutions, and community initiatives to support long-term financial well-being.',
      image: GovernmentImage,
      link: '/academy/government',
      color: 'from-[#F4900C] to-[#FED700]',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              WealthyCats <span className="text-[#F4900C]">Academy</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Building financial confidence through fun, practical, and real-world learning for individuals, groups, and organizations.
            </p>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8">
            {categories.map((category, index) => (
              <Link
                key={category.id}
                to={category.link}
                className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Background Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-br ${category.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                
                {/* Image Placeholder - Replace with actual images */}
                <div className="relative h-64 bg-gradient-to-br from-gray-200 to-gray-300 overflow-hidden">

                  <img 
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />

                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-6xl opacity-30">🎓</span>
                  </div>
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/60 to-transparent`}></div>
                  <div className="absolute bottom-4 left-4">
                    <h2 className="text-3xl font-bold text-white">{category.title}</h2>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    {category.description}
                  </p>
                  
                  <div className="flex items-center text-[#F4900C] font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    <span>Explore</span>
                    <svg 
                      className="w-5 h-5 ml-2" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </div>

                {/* Corner Decoration */}
                <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${category.color} opacity-20 rounded-bl-full`}></div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#FED700] to-[#F4900C]">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Not Sure Which Program is Right for You?
            </h2>
            <p className="text-lg text-gray-800 mb-8">
              Contact us and our team will help you find the perfect financial literacy program
            </p>
            <Link
              to="/contact"
              className="inline-block bg-white text-[#F4900C] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300 shadow-lg"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Academy;